import { toast } from "hooks";
import type {
  VerificationDataSource,
  VerificationStatus,
} from "hooks/firestore/v2/models/userVerifications";
import type { AppDispatch } from "store/createStore";
import { ACCOUNT_REDUX_EVENTS } from "types/Account";
import type { Nullable } from "types/utilities";
import type { CustomerLicence } from "utilities/Auth/authSlice";

export const handleFailedVerificationAttempt = (
  type: VerificationDataSource,
  licence: Nullable<CustomerLicence>,
  dispatch: AppDispatch,
) => {
  dispatch({
    type: ACCOUNT_REDUX_EVENTS.SUBMIT_VERIFICATION_ATTEMPT,
    payload: {
      outcome: "failure",
      type,
      licence,
    },
  });

  toast({
    title: "Unable to submit verification data",
    variant: "danger",
    description:
      "Something went wrong. Please contact support if the error persists",
  });
};

/** Maps user verification data sources to their respective route path */
export const verificationDataSourcePathMap: Record<
  VerificationDataSource,
  string
> = {
  AustralianDriversLicence: "australian-drivers-licence",
  AustralianPassport: "australian-passport",
  MedicareCard: "medicare",
  AustralianVisaCheck: "australian-visa",
  NewZealandDriversLicence: "nz-drivers-license",
  NewZealandPassport: "nz-passport",
  NationalId: "national-identification-system",
} as const;

/*
 * Maps user verification statuses to a format that is more readable for a user
 */
export const verificationStatusLabelMap: Record<VerificationStatus, string> = {
  UNVERIFIED: "Verify",
  IN_PROGRESS: "In progress",
  FAILED: "Unsuccessful",
  ERROR_OCCURRED: "Unsuccessful",
  VERIFIED: "Verified",
  VERIFIED_ADMIN: "Verified",
  PENDING_REVIEW: "In review",
} as const;
